<template>
  <div>
    <h2 class="pull-left pb-title w-100 mb-4 fs-5">
      {{ $t('account.create_an_account') }}
    </h2>

    <!-- TODO: @lames error styling -->
    <div v-show="regErrors.any()" class="alert alert-error alert alert-danger pull-left w-100" role="alert">
      <div v-for="(error, idx) in regErrors.flatten()" :key="idx">
        <div v-html="error"></div>
      </div>
    </div>

    <div class="form-group pull-left w-100 mb-2">
      <div class="col-sm-12 pl-0 pr-0 form-group">
        <input v-model.trim="email" :placeholder="email_username" class="form-control mb-2" data-cy="createEmail" type="email" @keydown.enter="register" />

        <input v-model="password" :placeholder="user_password" class="form-control mb-3" data-cy="createPassword" type="password" @keydown.enter="register" />

        <div v-show="recaptcha_is_v2" id="captcha_button" class="pull-left w-100"></div>
        <div class="form-check">
          <input v-model="tos_accepted" v-track="{ category: 'plan-builder', action: 'click', label: 'toggle-accept-tos' }" class="form-check-input" name="type" type="checkbox" />
          <label class="form-check-label"><span class="lbl" v-html="$t('account.tos')"></span></label>
        </div>
        <div class="form-check">
          <input v-model="newsletter_pref" v-track="{ category: 'plan-builder', action: 'click', label: 'toggle-opt-in' }" class="form-check-input" name="type" type="checkbox" />
          <label class="form-check-label">
            <span class="lbl">{{ $t('account.newsletter') }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="form-group pull-left w-100 mb-2 d-flex flex-column gap-4 mb-6">
      <button v-track="{ category: 'plan-builder', action: 'create-account', label: 'create-account-continue' }" class="btn-lg btn btn-success fw-bold" @click="register">
        <i v-if="loading" class="fa fa-spinner fa-spin"></i>
        <div v-else>{{ $t('account.create_account') }}</div>
      </button>

      <google-sign-in-button is-sign-up />
      <microsoft-sign-in-button is-sign-up />
    </div>
  </div>
</template>

<script>
import Errors from '../../../classes/errors';
import Captcha from '../../mixins/Captcha.js';
import GoogleSignInButton from './GoogleSignInButton';
import MicrosoftSignInButton from './MicrosoftSignInButton';

const CAPTCHA_FAILURE_TEXT = 'reCAPTCHA failed, you will need to successfully complete reCAPTCHA before logging in.';

export default {
  name: 'CreateAccount',

  mixins: [Captcha],

  components: {
    GoogleSignInButton,
    MicrosoftSignInButton
  },

  data() {
    return {
      email: '',
      password: '',
      tos_accepted: false,
      newsletter_pref: false,
      regErrors: new Errors(),
      loading: false
    };
  },
  computed: {
    email_username: function () {
      return this.$t('account.email_username');
    },
    user_password: function () {
      return this.$t('account.user_password');
    }
  },

  mounted: function () {
    if (!this.inside_eu()) {
      this.tos_accepted = true;
      this.newsletter_pref = true;
    }
  },

  methods: {
    register() {
      if (this.loading) {
        return;
      }

      this.submitCaptcha(this.postRegister);
    },
    postRegister() {
      let user_data = {
        'email': this.email,
        'password': this.password,
        'optin': this.newsletter_pref,
        'accepts_tos': this.tos_accepted,
        'limited': true,
        'g-recaptcha-response': this.captcha_token
      };

      this.loading = true;

      // eslint-disable-next-line no-undef
      axios
        .post('/xhr/register', user_data)
        .then(() => {
          this.loading = false;
          window.location.reload(true);
        })
        .catch(error => {
          this.loading = false;
          if (error.response.data.error === 'CAPTCHA_FAILURE') {
            this.recaptcha_is_v2 = true;
            this.regErrors.set([CAPTCHA_FAILURE_TEXT]);
          } else {
            this.regErrors.set(error.response.data.error);
          }
        });
    },
    inside_eu() {
      return !!parseInt(document.body.querySelector('input[name="_inside_eu"]').value);
    }
  }
};
</script>
